
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCurrent as ObiCurrentElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-current.js';
 
 
 

 
 export const ObiCurrent = createComponent({
   react: React,
   tagName: 'obi-current',
   elementClass: ObiCurrentElement,
   events: {
     
   }
  });
 
 